var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3075 21.0941H5.69254C3.18087 21.0941 1.14587 19.05 1.14587 16.5383V9.74581C1.14587 8.49914 1.91587 6.93164 2.90587 6.16164L7.84671 2.31164C9.33171 1.15664 11.7059 1.10164 13.2459 2.18331L18.9109 6.15248C20.0017 6.91331 20.8542 8.54498 20.8542 9.87414V16.5475C20.8542 19.05 18.8192 21.0941 16.3075 21.0941ZM8.69004 3.39331L3.74921 7.24331C3.09837 7.75664 2.52087 8.92081 2.52087 9.74581V16.5383C2.52087 18.2891 3.94171 19.7191 5.69254 19.7191H16.3075C18.0584 19.7191 19.4792 18.2983 19.4792 16.5475V9.87414C19.4792 8.99414 18.8467 7.77498 18.1225 7.27998L12.4575 3.31081C11.4125 2.57748 9.68921 2.61414 8.69004 3.39331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4275C10.6242 17.4275 10.3125 17.1158 10.3125 16.74V13.99C10.3125 13.6142 10.6242 13.3025 11 13.3025C11.3758 13.3025 11.6875 13.6142 11.6875 13.99V16.74C11.6875 17.1158 11.3758 17.4275 11 17.4275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overviewIcon.0c08132c4c5a63fc9fb2c1768510bd12.svg";
export { ForwardRef as ReactComponent };